import React, { createContext, useState } from 'react';

export const ModalContext = createContext();

const ModalContextProvider = ({ children }) => {
    const [activeModal, setActiveModal] = useState(null);
    const [modalProps, setModalProps] = useState(null);

    return (
        <ModalContext.Provider value={{
            activeModal: activeModal,
            isOpen: !!activeModal,
            modalProps: modalProps,
            setActiveModal: setActiveModal,
            setModalProps: setModalProps
        }}>
            {children}
        </ModalContext.Provider>
    );
};

export default ModalContextProvider;